import React, { Component } from "react"
import {// Button, DropdownButton, MenuItem, Modal,
            OverlayTrigger, Tooltip} from 'react-bootstrap'
import { searchTableFilter } from "../Tree/Utils.js"

import { FamilyWPsub } from './FamilyWPsub'

import SearchBar from '../Tree/components/SearchBar.jsx'
import { EditableCell } from '../TableList/EditableCell'
//import { ProductRow } from '../TableList/ProductRow'
import { taskStatus } from '../../variables/ComboValues'

// input (props) 
//      tableTitle={"תוכנית עבודה"}
//      familyCode - TBD
// Resources: see import above

const  microLegendTop = {
    familywp_expand: "הרחבה",
    familywp_goal: "יעד / מטרה",
    familywp_status: "סטטוס התקדמות",
    familywp_goal_comments: "הערות",
    familywp_goal_duedate: "ת. יעד"
}
const  microLegend = {
    familywp_goal: "מטרה",
    familywp_taskarray_description: "משימה",
    familywp_taskarray_responsible: "אחראי",
    familywp_taskarray_duedate: "ת. יעד",
    familywp_shlish1: "שליש 1",
    familywp_shlish2: "שליש 2",
    familywp_shlish3: "שליש 3",
    familywp_shlish4: "שליש 4",
    familywp_shlish5: "שליש 5",
    familywp_shlish6: "שליש 6",
    familywp_taskarray_comments: "הערות",
    familywp_taskarray_needsolution: "מענה מהתכנית"
}
const tips = {
  familywp_taskarray_comments: "התקדמות שליש תתחיל בשורה חדשה. בתחילתה הטקסט: ''שליש 1: והערות ככל שנדרש. כמובן לכל שליש המספר המתאים",
}
const tooltip = (text) => <Tooltip id="tooltip"><span style={{direction: 'rtl'}}>{text}</span></Tooltip>

export class FamilyWP4 extends Component {

    constructor(props) {
      super(props)
      this.state = { products: typeof this.props.data === "undefined" ||  this.props.data === false ? [] : this.props.data}
      this.onSaveTable = this.onSaveTable.bind(this)
      this.handleAddEvent = this.handleAddEvent.bind(this)
      this.handleRowDel = this.handleRowDel.bind(this)
      this.handleProductTable = this.handleProductTable.bind(this)
      this.mergeSubTable = this.mergeSubTable.bind(this)
    }
    
    handleRowDel(product) {
      const {products} = this.state
      var index = products.indexOf(product)
      if (index === -1)
        return console.log("FamilyRights productnot found", product)

      var array = [...products]
      array.splice(index, 1)
      this.setState({products:array})
    }
    
  
    handleAddEvent(evt) {
      evt.preventDefault()
      var id = (+ new Date() + Math.floor(Math.random() * 999999)).toString(36);
      var product = {
        id: id,
        familywp_goal: "",
        familywp_status: "",
        familywp_goal_duedate: "",
        familywp_goal_comments: "",
        familywp_goal_tasklist: []
      /*  familywp_goal: "",
        familywp_taskarray_description: "",
        familywp_taskarray_responsible: "",
        familywp_taskarray_duedate: "",
        familywp_shlish1: "",
        familywp_shlish2: "",
        familywp_shlish3: "",
        familywp_shlish4: "",
        familywp_shlish5: "",
        familywp_shlish6: "",
        familywp_taskarray_comments: "שליש 1: הערות כאן...." ,
        familywp_taskarray_needsolution: ""*/
      }
      let newp = ""
      if (typeof this.state.products === "undefined"){
        newp = [product]
      } else {
        newp = [...this.state.products]
        newp.unshift(product)
      }
      this.setState({products:newp})
      
    }
    
    // Add modified sub table
    mergeSubTable = (subtable, key) => {
        // console.log("mergeSubTable subtable key="+key+" subt= ", subtable )
        // find line from this.state.data with id === key
        let newp = [...this.state.products]
        let found = false
        let i=0
        for (i = 0; i < newp.length; i++)
          if (newp[i].id === key){
            found = true
            break
          }
        
        if (!found) {
          console.log ("mergeSubTable key = "+key+" not found in ", newp)
          return null
        }
        // remove subtable &  set new subtable
        newp[i]['familywp_goal_tasklist'] = subtable
        // set state
        this.setState({products: newp})
    }

    handleProductTable(evt) {
      evt.preventDefault()

      var item = {
        //id: evt.target.id,
        name: evt.target.name,
        value: evt.target.value,
        nid: evt.target.getAttribute('data-id')
    }
        // console.log("pRODUCT-EVT", item);

        var products = this.state.products.slice();
        // console.log("products-EVT", products);

        var newProducts = products.map(function(product) {
  
            for (var key in product) {
                if (key === item.name && product.id === item.nid) {
                    product[key] = item.value
                }
            }
            return product
        })
        this.setState({products:newProducts})
    }

    // update data base
    onSaveTable(evt) {
      evt.preventDefault()
      const { save2DB, subTableId, familyPostId, inUpdate, mbouser } = this.props
     // console.log("Family wp finance save table: products", this.state.products)
   
      save2DB(familyPostId, this.state.products, subTableId, "table", inUpdate, mbouser )
    }
    render() {
      const { tableTitle } = this.props
      let title = tableTitle === undefined ? "שם משפחה" : tableTitle
      // const { data } = this.props
      // console.log("Family general data", data)
      //console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable}
            mergeSubTable={this.mergeSubTable}

            headerColumns = {[microLegendTop['familywp_expand'],microLegendTop['familywp_goal'], microLegendTop['familywp_status'],
                          microLegendTop['familywp_goal_duedate'], microLegendTop['familywp_goal_comments']]}                  
            tableTitle = {title} 
            onRowAdd={this.handleAddEvent} 
            onRowDel={this.handleRowDel} 
            products={this.state.products} 
          />
      )
    }
  }
  /*   class SearchBar extends Component { moved to file */
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
        //this.mergeSubTable = this.mergeSubTable.bind(this)
    }
   // mergeSubTable(products){
   //     console.log("ProductTable mergeSubTable products", products)
   // }
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, onRowDel, onRowAdd, headerColumns, mergeSubTable,
            products, tableTitle, onSaveTable } = this.props
      var filterText = this.state.filterText;
      var thStyle = { fontSize: '15px',color:'#333', fontWeight: 'bold'}
      var buttonStyle = {marginRight: '0'}
      var searchbarStyle = {margin: '5px 10px'}
      var product = (typeof products === "undefined" || products === null || products === false)? [] : products.map(function(product) {
      //var product = products.map(function(product) {
          // check on all relevant data fields
          if (!searchTableFilter(product, filterText))
                return null;

        const cellData=[{
              type: "text",
              name: "familywp_goal",
              value: product.familywp_goal,
              id: product.id,
              style: {width: "220px"},
              edit: true
            },{
              type: "select",
              options: taskStatus,
              name: "familywp_status",
              value: product.familywp_status,
              id: product.id,
              style: {width: "160px"},
              edit: true
            },{
              type: "text",
              name: "familywp_goal_duedate",
              value: product.familywp_goal_duedate,
              id: product.id,
              style: {width: "150px"},
              placeholder: 'dd/mm/yyyy',
              edit: true
            },{
              type: "textarea",
              name: "familywp_goal_comments",
              value: product.familywp_goal_comments,
              id: product.id,
              style: {width: "250px"},
              edit: true
          }
        ]
        
        
        return (
          <ProductRow 
            onProductTableUpdate={onProductTableUpdate} 
            mergeSubTable = {mergeSubTable}
            product={product} 
            onDelEvent={onRowDel.bind(this)} 
            key ={product.id}
            lineNum ={product.id}
            cd={cellData}
            />)
      })

      return (
        <div className="yahav-modal">
            <h2>{tableTitle}&nbsp;(סה"כ&nbsp;{typeof products === "undefined"? 0 : products.length})</h2>
            <button style={buttonStyle} type="button" onClick={onRowAdd} className="btn btn-success pull-right">הוספת מטרה</button>
            <button style={buttonStyle} type="button"  className="btn btn-success pull-left" onClick={onSaveTable}>עדכון</button>
            <SearchBar style={searchbarStyle} filterText={this.state.filterText} onUserInput={this.handleUserInput.bind(this)} />
            <table className="table ">
                <thead>
                    <tr >
                    {headerColumns.map (col => { 
                      return(<th style={thStyle} key={col}>
                                {microLegend[col]?microLegend[col] : col}
                                { typeof tips[col] === "undefined" ? null :
                                      <OverlayTrigger placement="top" overlay={tooltip(tips[col])}>
                                          <i className="far fa-question-circle"></i>
                                      </OverlayTrigger>
                                }
                            </th>) 
                  }) } 
                  
                    </tr>
                </thead>  
                <tbody>
                    {product}
                </tbody>
            </table>
        </div>
      )
    }
  }

  class ProductRow extends Component {
    constructor(props){
        super(props)
        this.state = {rowopen:false}
        this.subTableUpdate = this.subTableUpdate.bind(this)
    }
    onToggleEvent(){
        //alert("toggle event")
        this.setState({rowopen: !this.state.rowopen})
        //console.log("product row toggle this.props.product", this.props.product)
    }
    onDelEvent() {
      this.props.onDelEvent(this.props.product)
    }
    downArrow(){
        return <span>&#9660;</span>
    }
    sideArrow(){
        return <span>&#x25C0;</span>
    }
    subTableUpdate(products){
       // console.log("subTableUpdate products", products)
       this.props.mergeSubTable(products, this.props.lineNum)
    }
    render() {
      const {onProductTableUpdate, cd} = this.props
      var key = 0
      //console.log("Row - product=", this.props.product.familywp_goal_tasklist)
      let subArray = this.props.product.familywp_goal_tasklist ? this.props.product.familywp_goal_tasklist : null
      return (
        <React.Fragment>

            <tr className="eachRow">
            <td className="toggle-cell">
                <span className="toggle-arrow" onClick={this.onToggleEvent.bind(this)}>
                    {this.state.rowopen ? this.downArrow() : this.sideArrow()  }
                </span>
                 
                </td>
            {cd.map(cellInfo => {
                return (<EditableCell key={key++} onProductTableUpdate={onProductTableUpdate} cellData={cellInfo} /> )
            })}
            
            <td className="del-cell">
                    <input type="button" onClick={this.onDelEvent.bind(this)} value="X" className="del-btn"/>
                </td>
            </tr>
            {this.state.rowopen && 
                <tr>
                    <td colSpan="8">
                        <table>
                          <tbody>
                            <tr>
                                <td>
                                    <FamilyWPsub data={subArray} onUpdate={this.subTableUpdate} />
            {/* <FamilyWP4 tableTitle={"תכנית עבודה כלכלה"} // onUpdate={this.props.subTableUpdate}
                            familyPostId={familyPostId} 
                            data={familywp_finance_2}
                            subTableId = {"familywp_finance_2"}
                            inUpdate = {this.inUpdate}
                            save2DB = {this.onSaveSubTable} /> */}
                                </td>
                            </tr>
                          </tbody>
                        </table>
                    </td>
                </tr>}
        </React.Fragment>

      )
  
    }
  
  }
  